import { IconButton } from "@chakra-ui/react";
import { CgFacebook, CgInstagram } from "react-icons/cg";

export const FacebookProfile = ({ size }: { size: number }) => {
  return (
    <IconButton
      as="a"
      _hover={{ color: "primary.500" }}
      href="https://www.facebook.com/profile.php?id=61560662393936"
      target="_blank"
      size={"md"}
      variant={"none"}
      aria-label="Przejdź do profilu facebook"
      icon={<CgFacebook size={size} />}
    />
  );
};

export const InstagramProfile = ({ size }: { size: number }) => {
  return (
    <IconButton
      as="a"
      _hover={{ color: "primary.500" }}
      href="https://www.instagram.com/wydawnictwodystans/"
      size={"md"}
      variant={"none"}
      target="_blank"
      aria-label="Przejdź do profilu instagram"
      icon={<CgInstagram size={size} />}
    />
  );
};
